import { render, staticRenderFns } from "./TooltipQuestion.vue?vue&type=template&id=2e2aae05"
import script from "./TooltipQuestion.vue?vue&type=script&lang=js"
export * from "./TooltipQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports